/**
 * Dynamic formatter for Pakistani CNIC / NTN.
 * CNIC: XXXXX-XXXXXXX-X (13 digits)
 * NTN: XXXXXXX-X (8 digits)
 */
export function formatCnicOrNtn(value: string): string {
  // Remove all non-digits
  const digits = value.replace(/\D/g, '');

  if (digits.length <= 8) {
    // Format as NTN: XXXXXXX-X
    if (digits.length > 7) {
      return `${digits.slice(0, 7)}-${digits.slice(7, 8)}`;
    }
    return digits;
  } else {
    // Format as CNIC: XXXXX-XXXXXXX-X
    let formatted = digits.slice(0, 5);
    if (digits.length > 5) {
      formatted += '-' + digits.slice(5, 12);
    }
    if (digits.length > 12) {
      formatted += '-' + digits.slice(12, 13);
    }
    return formatted;
  }
}

/**
 * Validates whether the given string is a valid CNIC or NTN format (digits only count).
 * CNIC: 13 digits
 * NTN: 8 digits
 */
export function isValidCnicOrNtn(value: string): boolean {
  const digits = value.replace(/\D/g, '');
  return digits.length === 8 || digits.length === 13;
}
